import { Injectable, inject, signal } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router } from '@angular/router';

/** Altura do menu fixo, descontada ao rolar até uma seção. */
const NAV_OFFSET = 80;

/** Navegação entre as seções da home e destaque da seção visível no menu. */
@Injectable({ providedIn: 'root' })
export class SectionNavigationService {
  private readonly router = inject(Router);
  private readonly scroller = inject(ViewportScroller);

  readonly activeSection = signal<string | null>(null);

  constructor() {
    this.scroller.setOffset([0, NAV_OFFSET]);
  }

  goTo(section: string): void {
    if (this.router.url.split('#')[0] === '/') {
      this.scroller.scrollToAnchor(section);
    } else {
      this.router.navigate(['/'], { fragment: section });
    }
  }

  /** Observa as seções e atualiza activeSection; retorna a função que encerra a observação. */
  observe(sectionIds: string[]): () => void {
    const observer = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.activeSection.set(entry.target.id);
          }
        }
      },
      { rootMargin: '-45% 0px -50% 0px' }
    );

    for (const id of sectionIds) {
      const element = document.getElementById(id);
      if (element) {
        observer.observe(element);
      }
    }

    return () => {
      observer.disconnect();
      this.activeSection.set(null);
    };
  }
}
